import { Chip, Tooltip } from "@mui/material"
import { styled } from "@mui/system"
import { Badge as BaseBadge, badgeClasses } from "@mui/base/Badge"
import { InvoiceReadModel, InvoiceState } from "../../../GeneratedClients/FreeBillApi"
import { useTranslate } from "react-admin"
import firstLetterToLowerCase from "../../../helpers/firstLetterToLowerCase"

interface IProps {
  invoice: InvoiceReadModel
  size?: "small" | "medium"
}

const InvoiceStateChip = ({invoice, size}: IProps) => {

  const translate = useTranslate()

  const Badge = styled(BaseBadge)(
    ({ theme }) => `
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-variant: tabular-nums;
    list-style: none;
    font-family: 'IBM Plex Sans', sans-serif;
    position: relative;
    display: inline-block;
    line-height: 1;
    & .${badgeClasses.badge} {
      z-index: auto;
      position: absolute;
      top: 3px;
      right: -1px;
      min-width: 18px;
      height: 18px;
      padding: 0 6px;
      color: #fff;
      font-weight: 600;
      font-size: 10px;
      line-height: 18px;
      white-space: nowrap;
      text-align: center;
      border-radius: 12px;
      background: #bb0000;
      transform: translate(50%, -50%);
      transform-origin: 100% 0;
    }
    & .${badgeClasses.invisible} {
      opacity: 0;
      pointer-events: none;
    }
    & .${badgeClasses.root}
    `,
  )

  const invisible = !invoice.reminderStepNumber || invoice.reminderStepNumber === 0 

  const color = (invoiceState?: InvoiceState) => {
    switch (invoiceState) {
      case InvoiceState.Paid:
        return "success"
      case InvoiceState.PastDue:
        return "error"  
      case InvoiceState.Pending:
        return "warning"
      case InvoiceState.Canceled:
        return "primary"   
      default:
        return "primary"
    }
  }

  return (
    <Tooltip title={`Mahnstufe ${invoice.reminderStepNumber}`} placement="right" disableHoverListener={invisible}>
      <Badge
        badgeContent={invoice.reminderStepNumber}
        color="error"
        invisible={invisible}
      >
        <Chip 
          label={translate(`resources.invoices.${firstLetterToLowerCase(invoice.invoiceState)}`)} 
          variant="filled"
          color={color(invoice.invoiceState)} 
          size={size}
        />
      </Badge>
    </Tooltip>
  )
}

export default InvoiceStateChip